export default __webpack_public_path__ + "static/media/signedUp.ec29e121.svg";